<template>
    <div id="notifications">

        <div class="header">
            <div class="meta">
                <h1 class="title">{{ $t('views.notifications.title') }}</h1>
            </div>
            <div class="content">

                <template v-for="(notification, feature) in notificationss">
                    <div
                        class="notification"
                        :class="{ inactive: notification == 0 }"
                        :key="feature"
                    >
                        <div class="meta">
                            <div class="label" v-if="feature == 'newFiles'">
                                <template v-if="notification"><div v-html="$t('views.notifications.new_files') + ' <b>' + $t('views.notifications.last_resources') + '</b>'"></div></template>
                                <template v-else><div v-html="$t('views.notifications.new_files_description') + ' <b>' + $t('views.notifications.last_resources') + '</b>'"></div></template>
                            </div>
                            <v-switch
                                style="margin-top: 0; padding-top: 0;"
                                v-model="notificationss[feature]"
                                dense
                                flat
                                hide-details
                                @change="notificationss = notificationss"
                            ></v-switch>
                        </div>
                    </div>
                </template>
            </div>

        </div>

    </div>
</template>

<script>


export default {
    name: 'Notifications',
    data () {
        return {
            notifications: {
                newFiles: true,
            },
        }
    },
    computed: {
        notificationss: {
            get: function () {
                return this.$store.getters['user/getNotifications']
            },
            set: function (newValue) {
                this.$store.dispatch('user/updateNotifications', newValue)
            }
        }
    },
    methods: {
        load () {
            var self = this;
            
            this.$overlay.loading()
            this.$store.dispatch('user/loadNotifications').then(function (response) {
                self.$overlay.hide()
            })
        },

        
    },
    created () {
        this.load()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#notifications {
    height: calc(100vh - 70px - 60px - 50px);

    .header {
        .title {
            margin-top: 50px;
        }
    }
    .content {
        display: flex;
        align-items: center;
        align-content: center;
        flex-direction: column;
        width: 80%;
        margin: 60px auto 10px;

        .notification {
            display: flex;
            align-items: center;
            background: url("/img/bell_active.svg") no-repeat;
            background-size: 25px;
            background-position: left center;
            // @include background($image: img('bell_second.svg'), $size: 20px, $position: left center);
            align-content: center;
            width: 100%;
            padding-left: 35px;
            margin: 10px auto;

            .meta {
                display: flex;
                align-items: center;
                border-radius: 5px;
                box-shadow: 0 0 9;
                padding: 9px 12px;
                width: 100%;
                background-color: #eee;
                min-height: 50px;
                height: fit-content;

                .label {
                    display: inline-flex;
                    font-size: 16px;
                    width: calc(100% - 50px);
                    color: #000;
                    // font-weight: bold;
                }

                .input-container {
                    display: inline-flex;
                    max-width: 200px;
                    margin: 0;
                }
            }

            &.inactive {
                // @include background($image: img('bell_disabled_inactive.svg'), $size: 20px, $position: left center);
                background: url("/img/bell_inactive.svg") no-repeat;
                background-size: 25px;
                background-position: left center;
            }
        }
    }
}
</style>
